// L'EFFACEUR — Empty State (page sans données)
// Affichage cohérent quand y a 0 mission, 0 ticket, 0 alerte, etc.

const EmptyState = ({
  icon: Icon,
  title,
  description,
  action = null,
  size = 'md', // sm | md | lg
}) => {
  const sizeClasses = {
    sm: { padding: 'p-6', iconSize: 'w-8 h-8', titleSize: 'text-base' },
    md: { padding: 'p-10', iconSize: 'w-12 h-12', titleSize: 'text-lg' },
    lg: { padding: 'p-16', iconSize: 'w-16 h-16', titleSize: 'text-xl' },
  };
  const s = sizeClasses[size] || sizeClasses.md;

  return (
    <div className={`glass-card border border-gray-800 ${s.padding} text-center`}>
      {Icon && (
        <div className="inline-flex items-center justify-center mb-4">
          <Icon className={`${s.iconSize} text-cyan-400/40`} />
        </div>
      )}
      <h3 className={`font-orbitron font-bold text-white mb-2 ${s.titleSize}`}>
        {title}
      </h3>
      {description && (
        <p className="text-gray-400 text-sm mb-4 max-w-md mx-auto leading-relaxed">
          {description}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
};

export default EmptyState;
